import { booleanAttribute, Component, input, output } from '@angular/core';

@Component({
  selector: 'lepi-color-picker-item',
  templateUrl: './color-picker-item.component.html',
  imports: [],
})
export class ColorPickerItemComponent {
  setColor = output<string>();
  remove = output<void>();
  color = input<string>('');
  removeMode = input<boolean, string>(false, { transform: booleanAttribute });

  handleRemove(ev: MouseEvent) {
    ev.stopPropagation();
    ev.preventDefault();

    this.remove.emit();
  }
}
